export const checksRulesInitialDataState = {
  members: [],
  telegramChats: []
};